import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateExpenseCategoryForm from "../../forms/CreateOrUpdateExpenseCategoryForm";
import { ExpenseCategoryResponseDto } from "../../shared/dtos/expenseCategory/ExpenseCategoryResponseDto";

interface UpdateExpenseCategoryModalProps {
  open: boolean;
  onClose: () => void;
  category: ExpenseCategoryResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateExpenseCategoryModal: React.FC<UpdateExpenseCategoryModalProps> = ({
  open,
  onClose,
  category,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${category.name}`}
    width="md"
    loading={loading}
  >
    <CreateOrUpdateExpenseCategoryForm
      isEditing={true}
      category={category}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateExpenseCategoryModal;
